<nav class="navbar">
	<div class="navbar navbar-left">
		<button class="btn btn-primary" (click)="editEntrepriseRequests$.next(null)">Ajouter une entreprise</button>
	</div>
	<div class="navbar navbar-left">
		<button class="btn btn-primary" (click)="exportRequests$.next()">Exporter</button>
	</div>
</nav>

<div class="mat-elevation-z8">
	<mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
	<table mat-table matSort [dataSource]="dataSource">
		<ng-container matColumnDef="id">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
			<td mat-cell *matCellDef="let data"> {{ data.id }} </td>
		</ng-container>

		<ng-container matColumnDef="nom">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> Nom </th>
			<td mat-cell *matCellDef="let data"> {{ data.nom }} </td>
		</ng-container>

		<ng-container matColumnDef="adresseVille">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> Ville </th>
			<td mat-cell *matCellDef="let data"> {{ data.adresseVille }} </td>
		</ng-container>
		
		<ng-container matColumnDef="documentApplicable">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> Document applicable </th>
			<td mat-cell *matCellDef="let data">
				{{ data.documentApplicable === 'Both' ? 'PDP / PA' : (data.documentApplicable === 'PlanPrevention' ? 'PDP' : 'PA') }}
			</td>
		</ng-container>

		<ng-container matColumnDef="obsolete">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> Actif </th>
			<td mat-cell *matCellDef="let data"> {{ data.obsolete ? 'Non' : 'Oui' }} </td>
		</ng-container>

		<ng-container matColumnDef="actions">
			<th mat-header-cell *matHeaderCellDef>&nbsp;</th>
			<td mat-cell *matCellDef="let data">
				<div class="actionButtons">
					<button type="button" (click)="editEntrepriseRequests$.next(data)" class="btn btn-primary">Modifier</button>
					<button type="button" (click)="delete(data)" class="btn btn-danger">Supprimer</button>
				</div>
			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
	</table>
	<mat-paginator #paginator showFirstLastButtons [pageSizeOptions]="[5, 10, 20, 50]" 
		[pageSize]="10" aria-label="Choisissez une page">
	</mat-paginator>
</div>

<nav class="navbar footer">
	<div class="navbar navbar-left">
		<button class="btn btn-primary" (click)="editEntrepriseRequests$.next(null)">Ajouter un entreprise</button>
	</div>
	<div class="navbar navbar-left">
		<button class="btn btn-primary" (click)="exportRequests$.next()">Exporter</button>
	</div>
</nav>

<edit-entreprise
	[openRequests]="editEntrepriseRequests$"
	(entrepriseCreated)="reloadList()"
	(entrepriseUpdated)="reloadList()">
</edit-entreprise>